module.exports = __webpack_public_path__ + "static/media/emptyState.e3618e09.png";